<script>

import {mapActions} from 'vuex';

import utils from "../../utils";
import LoginTemplate from "./LoginTemplate";

export default {
    components: {
        LoginTemplate
    },
    data() {
        return {
            loginField: '',
            username: '',
            password: '',
            error: ''
        }
    },
    computed: {
        isValidToSubmit: function () {
            let self = this;
            return self.username && self.password
        },
        loginPlaceholder: function () {
            return this.$t("login");
        }
    },
    methods: {
        ...mapActions(['login']),
        doLogin: function () {

            let self = this;
            self.$loader.show()
            self.error = '';

            this.login({
                username: self.username,
                password: self.password
            }).then(response => {

                self.$loader.hide();
                self.$router.push({path: "/"});

            }).catch((err) => {

                console.log("Error!");
                console.log(err);

                self.error = self.loginPlaceholder + '/Senha inválida';
                self.$loader.hide()

            })
        }
    }
}
</script>

<template>

    <login-template>

        <div class="login">
            <h2 class="form-header">{{ $t('loginPage') }}</h2>

            <div class="min-height">
                <div class="alert alert-mini alert-danger" v-if="error">
                    <strong>Error!</strong> {{ error }}
                </div>
            </div>

            <form autocomplete="off">
                <fieldset>

                    <div class="form-group">
                        <div class="input-group">
                                            <span class="input-group-addon"><i
                                                class="glyphicon glyphicon-user"></i></span>
                            <input type="text"
                                   name="username"
                                   class="form-control"
                                   :placeholder="loginPlaceholder"
                                   required=""
                                   v-model="username"
                                   id="username">
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="input-group">
                                            <span class="input-group-addon"><i
                                                class="glyphicon glyphicon-lock"></i></span>
                            <input
                                type="password"
                                name="password"
                                class="form-control"
                                :placeholder="$t('password')"
                                required=""
                                v-model="password" id="password"
                            >
                        </div>
                    </div>

                    <div style="padding-top: 20px;">

                        <el-button type="primary" native-type="submit" @click.prevent="doLogin()"
                                   :disabled="!isValidToSubmit" class="form-btn">
                            {{ $t("loginPage") }}
                        </el-button>

                    </div>

                </fieldset>
            </form>

            <div style="padding-top: 30px">
                <router-link :to="{ path: '/forgetPassword' }" tag="a">
                    {{ $t("forgotMyPassword") }}
                </router-link>
            </div>

        </div>
    </login-template>
</template>




// WEBPACK FOOTER //
// Login.vue?1df009da